module.exports = require("core-js/modules/es.array-buffer.constructor.js");